import { getResponseQuery } from "@helpers/_functions";

import http from "../../http-common";
import BaseService from "../base.service";

class SurveyRequestTemplate extends BaseService {
  constructor() {
    super("survey-request-templates");
  }

  duplicate(surveyRequestTemplateId) {
    return getResponseQuery(
      http.post(`${this.path}/duplicate/${surveyRequestTemplateId}`)
    );
  }
}

export default new SurveyRequestTemplate();
